import { TagType } from '@sib/api';
import { Contact, Tag } from '@sib/ui/icons';
import { ComboboxTagOptionProps } from '@sib/ui/types';
import { TaskTagCategory } from '@sib/utils';

type CategoryIcon = typeof Contact | typeof Tag;

export const createCategoryHeader = (
  category: TaskTagCategory,
  label: string,
  icon: CategoryIcon,
  color: string,
  categoryItems: ComboboxTagOptionProps[],
  field: TagType
): ComboboxTagOptionProps => ({
  value: `category-header-${category}`,
  label,
  isCollapsible: true,
  icon,
  color,
  categoryItems: categoryItems.map(item => ({
    ...item,
    field,
  })),
  field,
});
